export default "__VITE_ASSET__0xL6veZo__"